import {Directive, Inject, AfterViewInit, Input} from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwBlurWhen
 * @module mw.components.blurWhen
 * @restrict A
 *
 * @description
 * `mw-blur-when` is an attribute directive will tell an input when to blur.
 *
 * @usage
 * <hljs hljs-language="html">
 * <div mw-blur-when="$ctrl.blurFlag">
 * </div>
 * </hljs>
 */
@Directive({
    selector: '[mwBlurWhen]'
})
export class BlurWhenDirective implements AfterViewInit {

    @Input('=') mwBlurWhen: string;

    constructor(@Inject('$element') private $element: ng.IRootElementService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    ngAfterViewInit() {
        this.$scope.$watch(() => this.mwBlurWhen, shouldBlur => {
            if (shouldBlur) {
                this.$timeout(() => {
                    this.$element[0].blur();
                }, 81);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/input/blur-when.directive.ts